var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "invoice-detail",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("Receiver", {
              attrs: {
                "is-loading": _vm.loading,
                disabled: _vm.loading || _vm.stamped
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-6" },
          [
            _c("VoucherDetails", {
              attrs: {
                disabled: _vm.loading || _vm.stamped,
                "is-loading": _vm.loading
              }
            })
          ],
          1
        ),
        _vm.voucherPaymentMethod === "PPD"
          ? _c("div", { staticClass: "column is-12" }, [_c("Payments")], 1)
          : _vm._e(),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            !_vm.loading
              ? _c("Concepts", {
                  attrs: {
                    "is-loading": _vm.loading,
                    disabled: _vm.loading || _vm.stamped
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("CfdisRelatedReplacement", {
              attrs: {
                "replacement-type": "replacementInvoice",
                disabled: _vm.loading || _vm.stamped
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [_c("Comments", { attrs: { disabled: _vm.loading || _vm.stamped } })],
          1
        ),
        _c("div", { staticClass: "column is-12 action-buttons" }, [
          _vm.stamped || _vm.canceled
            ? _c("div", { staticClass: "field is-grouped" }, [
                _vm.stamped && !_vm.canceled
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-info",
                          class: { "is-loading": _vm.loading }
                        },
                        [_vm._v("\n            Factura Timbrada\n          ")]
                      )
                    ])
                  : _vm._e(),
                _vm.canceled
                  ? _c("p", { staticClass: "control" }, [
                      _c(
                        "a",
                        {
                          staticClass: "button is-danger",
                          class: { "is-loading": _vm.loading }
                        },
                        [_vm._v("\n            Factura Cancelada\n          ")]
                      )
                    ])
                  : _vm._e(),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.loading },
                        attrs: {
                          disabled: _vm.loading,
                          to: { name: "InvoicesHistory" }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
            : _c("div", { staticClass: "field is-grouped" }, [
                _c("p", { staticClass: "control" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      class: { "is-loading": _vm.loading },
                      attrs: { disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.setStamp(false)
                        }
                      }
                    },
                    [_vm._v("\n            Guardar\n          ")]
                  )
                ]),
                _c("p", { staticClass: "control" }, [
                  _c(
                    "button",
                    {
                      staticClass: "button is-success",
                      class: { "is-loading": _vm.loading },
                      attrs: { type: "submit", disabled: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.setStamp(true)
                        }
                      }
                    },
                    [_vm._v("\n            Guardar y Timbrar\n          ")]
                  )
                ]),
                _c(
                  "p",
                  { staticClass: "control" },
                  [
                    _c(
                      "RouterLink",
                      {
                        staticClass: "button",
                        class: { "is-loading": _vm.loading },
                        attrs: {
                          disabled: _vm.loading,
                          to: {
                            name: "StampedList",
                            query: { size: 20, page: 1 }
                          }
                        }
                      },
                      [_vm._v("\n            Regresar\n          ")]
                    )
                  ],
                  1
                )
              ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }